import { TKohderekisteriName } from "@/sg-kohderekisterit/index";
import { getRequiredEnviromentVariable, getBooleanEnviromentVariable } from "../../sg-core/utils/enviroment.helpers copy";

interface IEnviromentVariables {
    production: boolean;
    publicUrl: string;
    apiBaseUrl: string;
    siteLogo: string;
    kohderekisteri: TKohderekisteriName,

    showAuditSummary?: boolean,

    companyName?: string,

    pdfGenerateUrl?: string;
    developmentPdfGenerationUrl?: string;

    applicationMenuHref?: string,
    showDeveloperSettings?: boolean,

    emailSupport?: boolean,
    smsSupport?: boolean,
    mapSupport?: boolean,
};

export const EnviromentVariables: IEnviromentVariables = {
    siteLogo: "/site-logo.png",
    kohderekisteri: getRequiredEnviromentVariable("REACT_APP_KOHDEREKISTERI") as TKohderekisteriName,
    apiBaseUrl: getRequiredEnviromentVariable("REACT_APP_API_BASE_URL"),

    showAuditSummary: getBooleanEnviromentVariable("REACT_APP_SHOW_AUDIT_SUMMARY"),

    companyName: process.env.REACT_APP_COMPANY_NAME,

    emailSupport: getBooleanEnviromentVariable("REACT_APP_EMAIL_SUPPOR"),
    smsSupport: getBooleanEnviromentVariable("REACT_APP_SMS_SUPPORT"),
    mapSupport: getBooleanEnviromentVariable("REACT_APP_MAP_SUPPORT"),
    showDeveloperSettings: getBooleanEnviromentVariable("REACT_APP_SHOW_DEVELOPER_SETTINGS"),

    applicationMenuHref: process.env.REACT_APP_APPLICATION_MENU_HREF,

    production: process.env.NODE_ENV === "production",
    publicUrl: process.env.PUBLIC_URL,
    pdfGenerateUrl: process.env.REACT_APP_PDF_GENERATOR_URL,
    developmentPdfGenerationUrl: process.env.REACT_APP_LOCAL_DEVELOPMENT_PDF_URL,
};